import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Home page ships pre-rendered HTML (public/index.html); hydrate it, otherwise render fresh.
if (container.hasChildNodes() && window.location.pathname === "/") {
  ReactDOM.hydrateRoot(container, app, { onRecoverableError: (e) => { window.__hydrationError = String(e?.message || e); } });
} else {
  ReactDOM.createRoot(container).render(app);
}

// Register PWA Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
